package org.example.project.screens_shared

import androidx.compose.runtime.Composable
import org.example.project.dashboard.CusBereichWrapper

@Composable
fun SHAREDSnapAuftraegeDashboard(node: String) {
    CusBereichWrapper(
        screenKey = "SnapMeineAuftraegeDashboard",
        node = node,
        buttonLabels = mapOf(
            "SnapAuftragsDashboard" to "SNAP Aufträge",
            "MeineSlotAuftraege" to "Alle Aufträge",
            "MeineFahrerAuftraege" to "Nach Fahrer"
        )
    )
}
